/** Movement tuning that is the same for every mech (per-mech numbers live in data/mechs/*.json). */
/** Heavier-than-Earth gravity for a weighty, readable jump arc (m/s^2). */
export const GRAVITY = 24;
export const TERMINAL_FALL_SPEED = 45;
/** Ticks after leaving an edge during which a jump still counts as grounded. */
export const COYOTE_TICKS = 3;
/** Backpedalling is slower than moving forward. */
export const BACKPEDAL_FACTOR = 0.75;
/** Ticks without spending energy before regeneration resumes (0.8 s at 30 Hz). */
export const ENERGY_REGEN_DELAY_TICKS = 24;
/** Below this ground speed the mech counts as idle (m/s). */
export const IDLE_SPEED = 0.05;
//# sourceMappingURL=constants.js.map